import {connect} from "react-redux";
import CreateLeads from "./CreateLeads";
import {bindActionCreators} from "redux";
import {saveLead, getLeadById} from "../../../service/Lead/action";

const mapStateToProps = (state) => ({
    lead:state.Lead.lead,
    leadById:state.Lead.leadById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveLead,
            getLeadById,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CreateLeads);
